module.exports = __webpack_public_path__ + "static/media/hat-wizard.03fa1ea2.svg";